import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { navigateAndScroll } from '../utils/navigation';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Chip from '@mui/material/Chip';
import HomeIcon from '@mui/icons-material/Home';
import HistoryIcon from '@mui/icons-material/History';
import DescriptionIcon from '@mui/icons-material/Description';
import SettingsIcon from '@mui/icons-material/Settings';
import Dashboard from '../components/Dashboard';

const navItems = [
  { label: 'Overview', icon: <HomeIcon /> },
  { label: 'Booking History', icon: <HistoryIcon /> },
  { label: 'Reports', icon: <DescriptionIcon /> },
  { label: 'Settings', icon: <SettingsIcon /> },
];

function ClientDashboard() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Dashboard title="My Account" navItems={navItems}>
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
        Welcome!
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 4 }}>
        Manage your cybersecurity assessments and view reports.
      </Typography>

      {/* Quick Action */}
      <Box sx={{ mb: 4 }}>
        <Button
          variant="contained"
          size="large"
          onClick={() => navigateAndScroll(navigate, '/book', location.pathname)}
          sx={{ px: 4 }}
        >
          Book New Assessment
        </Button>
      </Box>

      {/* Summary Cards */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={4}>
          <Card elevation={0} variant="outlined">
            <CardContent sx={{ textAlign: 'center' }}>
              <Typography color="text.secondary" variant="body2">
                Total Assessments
              </Typography>
              <Typography variant="h4" sx={{ fontWeight: 700, color: '#1e3a8a' }}>
                0
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Card elevation={0} variant="outlined">
            <CardContent sx={{ textAlign: 'center' }}>
              <Typography color="text.secondary" variant="body2">
                Pending
              </Typography>
              <Typography variant="h4" sx={{ fontWeight: 700, color: '#f59e0b' }}>
                0
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Card elevation={0} variant="outlined">
            <CardContent sx={{ textAlign: 'center' }}>
              <Typography color="text.secondary" variant="body2">
                Completed
              </Typography>
              <Typography variant="h4" sx={{ fontWeight: 700, color: '#16a34a' }}>
                0
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Booking History */}
      <Paper variant="outlined" sx={{ p: 3, mb: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Recent Bookings
          </Typography>
          <Chip label="0 bookings" size="small" />
        </Box>
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography color="text.secondary" sx={{ mb: 2 }}>
            You have no bookings yet.
          </Typography>
          <Button variant="outlined" onClick={() => navigateAndScroll(navigate, '/book', location.pathname)}>
            Book Your First Assessment
          </Button>
        </Box>
      </Paper>

      {/* Assessment Reports */}
      <Paper variant="outlined" sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Assessment Reports
          </Typography>
          <Chip label="0 reports" size="small" />
        </Box>
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography color="text.secondary">
            Completed assessment reports will appear here.
          </Typography>
        </Box>
      </Paper>
    </Dashboard>
  );
}

export default ClientDashboard;
